import { uniqueId } from 'utils/Numbers';
import { CustomSalaryComponent } from './types';
import { EarningsComponentType } from 'components/SalaryComponents/types';
import { ReviseSalaryFormData } from '../../constants';

export const sortComponentsListByComponentType = ({
  components,
}: {
  components: CustomSalaryComponent[];
}) => {
  return [...components].sort((component1, component2) => {
    if (component1.componentType === 'COMPONENT_TYPE_BASIC') return -1;
    if (component2.componentType === 'COMPONENT_TYPE_BASIC') return 1;

    // Special Allowance comes last
    if (component1.componentType === 'COMPONENT_TYPE_SPECIAL_ALLOWANCE') return 1;
    if (component2.componentType === 'COMPONENT_TYPE_SPECIAL_ALLOWANCE') return -1;

    return 0;
  });
};

export const getNewComponent = (): CustomSalaryComponent => ({
  id: uniqueId(),
  componentId: "",
  name: '',
  amount: '',
  isPredefined: false,
  componentType: 'COMPONENT_TYPE_NA',
  category: 'EARNINGS_CATEGORY',
});

export const getInitialCustomComponents = ({
  exisitingCustomSalaryStructure,
  allNonAdhocComponents,
  formData,
}: {
  exisitingCustomSalaryStructure: CustomSalaryComponent[];
  allNonAdhocComponents: EarningsComponentType[];
  formData: Partial<ReviseSalaryFormData>;
}): CustomSalaryComponent[] => {
  if (formData.isCustomSalaryStructure && formData.customSalaryComponents) {
    return formData.customSalaryComponents;
  }
  if (exisitingCustomSalaryStructure.length) {
    return exisitingCustomSalaryStructure;
  }
  return allNonAdhocComponents
    .filter((comp) => comp.isPredefined)
    .map((comp) => ({
      id: uniqueId(), //row id for uniqueness
      componentId: comp.id,
      name: comp.name,
      amount: '',
      isPredefined: comp.isPredefined ?? false,
      category: comp.category,
      componentType: comp.componentType,
    }));
};

export const getComponentDescription = (component: EarningsComponentType) => {
  if (component.componentType === 'COMPONENT_TYPE_NON_PAYABLE_BENEFIT') {
    return 'Non-Payable Benefit';
  }
  return `Earning (${component.componentType === 'COMPONENT_TYPE_VARIABLE' ? 'Variable' : 'Monthly'
    })`;
};

export const validateCustomSalaryStructure = (components: CustomSalaryComponent[]) => {
  const hasError = components.some((component) => component.componentType !== 'COMPONENT_TYPE_SPECIAL_ALLOWANCE' && (!component.componentId || !component.amount || component.amount === '0'));
  return hasError ? 'Please ensure all salary components have a valid component selected and an amount greater than 0' : null;
}